export enum TransactionalServiceType {
  ApplicationOrRenewal = 'application_or_renewal',
  Registration = 'registration',
  BookingsOrAppointments = 'bookings_or_appointments',
  SubscriptionOrNotification = 'subscription_or_notification',
  Others = 'others',
  FeedbackOrContactForm = 'feedback_or_contact_form',
  Payment = 'payment',
  InformationalService = 'informational_service',
}
